function disableScroll() {
    // Pour la plupart des navigateurs
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
}

function enableScroll() {
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
}
disableScroll();

jQuery(document).ready(function ($) {

    gsap.to(".text1", {x: "-100%", duration: 34, repeat: -1, ease: "linear"});
    gsap.to(".text2", {x: "100%", duration: 45, repeat: -1, ease: "linear"});
    gsap.to(".text3", {x: "-100%", duration: 55, repeat: -1, ease: "linear"});

    setTimeout(() => {
        gsap.to(".overlay-loader", {
            opacity: 0, duration: 1, onComplete: () => {
                enableScroll();

                $('.overlay-loader').remove();
            }
        });
    }, 0);

    function disableScroll() {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
    }

    function enableScroll() {
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
    }
});


document.addEventListener("DOMContentLoaded", function () {
    if (typeof ScrollTrigger !== "undefined") {
        gsap.registerPlugin(ScrollTrigger);
    }

    function animateElements(selector, animationProps) {
        const elements = document.querySelectorAll(selector);
        if (elements.length === 0) return;

        elements.forEach((element) => {
            gsap.from(element, {
                ...animationProps,
                scrollTrigger: {
                    trigger: element,
                    start: "top 85%",
                    toggleActions: "play none none reverse"
                }
            });
        });
    }

    animateElements(".animFromTopToBottom", { y: -50, opacity: 0, duration: 1, ease: "power3.out" });
    animateElements(".animFromLeftToRight", { x: -100, opacity: 0, duration: 1, ease: "power3.out" });
    animateElements(".animFromRightToLeft", { x: 100, opacity: 0, duration: 1, ease: "power3.out" });
});
